import mutations from '@/store/modules/cloud/integrations/integrations.mutation';
import actions from '@/store/modules/cloud/integrations/integrations.action';

export interface State {
  installed: any[];
  available: any[];
  projects: any[];
}

const state: State = {
  installed: [],
  available: [],
  projects: [],
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
};
